import React, { memo } from 'react';
import classNames from 'classnames';
import { primaryGradient, tertiaryColor, purple, linkColor, colorsNew, } from 'root/src/client/web/commonStyles';
import orEmpty from 'root/src/shared/util/orEmpty';
import { withStylesHof } from 'root/src/client/util/withStylesHof';
const checkMarkSize = 10;
const styles = {
    root: {
        position: 'relative',
    },
    inlineButton: {
        display: 'inline-block',
        padding: '0px 15px',
    },
    radioButton: {
        position: 'absolute',
        opacity: 0,
        height: 0,
        width: 0,
    },
    container: {
        display: 'block',
        position: 'relative',
        cursor: 'pointer',
        fontSize: 16,
        height: 16,
        width: 16,
        minHeight: 16,
        minWidth: 16,
    },
    checkMarkContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        borderRadius: '50%',
        border: `2px solid ${tertiaryColor}`,
    },
    label: {
        padding: [[0, 0, 0, 10]],
        cursor: 'pointer',
    },
    checkMarkContainerActive: {
        border: `2px solid ${purple}`,
    },
    checkMark: {
        position: 'absolute',
        top: `calc(50% - ${checkMarkSize / 2}px)`,
        left: `calc(50% - ${checkMarkSize / 2}px)`,
        height: checkMarkSize,
        width: checkMarkSize,
        borderRadius: '50%',
    },
    checked: {
        backgroundImage: primaryGradient,
    },
    iconWrapper: {
        position: 'absolute',
        right: 4,
        top: 8,
        width: 20,
        cursor: 'pointer',
    },
    icon: {
        width: '100%',
    },
    cardButton: {
        height: 300,
        width: 240,
        padding: [[8, 8, 12]],
        display: 'flex',
        flexDirection: 'column-reverse',
        justifyContent: 'space-around',
        alignItems: 'center',
        border: `1px solid ${tertiaryColor}`,
        backgroundColor: colorsNew.dark2,
        borderRadius: 4,
        cursor: 'pointer',
        margin: 10,
    },
    cardButtonActive: {
        border: `1px solid ${purple}`,
    },
    subLabel: {
        textAlign: 'center',
        height: 20,
    },
    labelCard: {
        padding: 0,
        fontSize: 26,
        fontWeight: 500,
    },
    featureList: {
        paddingInlineStart: '20px',
    },
    feature: {
        margin: 8,
    },
    featureNoBullet: {
        '&::marker': {
            fontSize: 0,
            color: 'transparent',
        },
        margin: [[0, 0, 0, -14]],
        fontSize: 17,
    },
    link: {
        color: linkColor,
        cursor: 'help',
    },
    noMargin: {
        margin: 0,
    },
};
const RadioButton = memo(({ classes, id, checked, label, onClick, className, customIcon, onClickCustom, isCard, features = [], subLabel, noRadio, noMargin, isInlineRadioButton, }) => (<div key={id} className={isInlineRadioButton ? classes.inlineButton : ''}>
		<div data-active={checked} className={classNames('layout-row', classes.root, ...orEmpty(isCard, [
        classes.cardButton,
        ...orEmpty(checked, [classes.cardButtonActive]),
        ...orEmpty(noMargin, [classes.noMargin]),
    ]), className)} {...(isCard ? { onClick } : {})}>
			{!noRadio && (
    /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
    <label id={id} className={classes.container} onClick={onClick}>
					<input className={classes.radioButton} type="radio"/>
					<span className={classNames(classes.checkMarkContainer, { [classes.checkMarkContainerActive]: checked })}>
						<span className={classNames(classes.checkMark, { [classes.checked]: checked })}/>
					</span>
				</label>)}
			{isCard
        && (<div className="flex layout-align-space-around-center">
					<div className={classes.subLabel}>
						{isSubLabelObject(subLabel)
                ? (<a className={classes.link} href={`mailto:${subLabel.mailto}`} target="_blank" rel="noopener noreferrer">{subLabel.text}
								</a>)
                : subLabel}
					</div>
					<ul className={classes.featureList}>
						{features.map((feature) => {
                const text = isFeatureObject(feature) ? feature.text : feature;
                const noBullet = isFeatureObject(feature) ? feature.noBullet : false;
                return (<li className={classNames(classes.feature, noBullet && classes.featureNoBullet)} key={text}>
									{text}
								</li>);
            })}
					</ul>
				</div>)}
			<span className={classNames(classes.label, isCard && classes.labelCard)} onClick={onClick}>
				{label}
			</span>
			{customIcon && !checked && (<div className={classes.iconWrapper} onClick={onClickCustom}>
					<img className={classes.icon} src={customIcon} alt="icon"/>
				</div>)}
		</div>
	</div>));
const isSubLabelObject = (subLabel) => {
    if (!subLabel) {
        return false;
    }
    if (typeof subLabel === 'string') {
        return false;
    }
    return 'mailto' in subLabel;
};
const isFeatureObject = (feature) => {
    if (typeof feature === 'string') {
        return false;
    }
    return 'text' in feature && 'noBullet' in feature;
};
export default withStylesHof(styles, { name: 'MuiRadioButton' }, RadioButton);
